import { isApiClientError } from '@ps/api-client';
import { QueryClient } from '@tanstack/react-query';

/**
 * Caching tuned for a weak connection: results stay fresh for a while, focus
 * changes do not refetch, and a request that failed because the input was
 * rejected is never retried.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: (failureCount, error) => {
        // 4xx means the server understood and refused — repeating changes nothing.
        if (isApiClientError(error) && error.status !== null && error.status < 500) return false;
        return failureCount < 2;
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
    },
    mutations: {
      // Writes are never retried automatically. A booking or a payment is
      // repeated only behind an explicit idempotency key.
      retry: false,
    },
  },
});
